import { APP_PAGES_NAMES } from 'constants/routes';

export const getPostFormTargetPageName = (isRestore: boolean) => {
  if (isRestore) {
    return APP_PAGES_NAMES.LOANS_OFFERS_RESTORE;
  }

  return APP_PAGES_NAMES.CREDIT_FULL_DEAL;
};
